import { variantShadow } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/shared/variantUtils';
import styled, { CSSProperties } from 'styled-components';

interface VariantPointProps {
    color: string;
    style?: CSSProperties;
    className?: string;
}

export const VariantPoint = (props: VariantPointProps) => {
    return (
        <S_VariantPoint className={props.className} style={props.style}>
            <S_Circle
                style={{
                    backgroundColor: props.color
                }}
            />
        </S_VariantPoint>
    );
};

const S_VariantPoint = styled.div`
    box-shadow: ${variantShadow};
    border-radius: 50%;
    width: 18px;
    height: 18px;
    background-color: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.black};
    display: flex;
    align-items: center;
    justify-content: center;
`;

const S_Circle = styled.div`
    width: 10px;
    height: 10px;
    border-radius: 50%;
`;
